export default "__VITE_ASSET__NFEoeI2M__"